import QuestoesAmbientaisAPI from "api/forms/questoes_ambientais";
import { PacoteStatusEnum } from "enum/pacoteStatus.enum";
import { create } from "zustand";

export interface IQuestoesAmbientais {
    uuid: string
    createdAt: string
    updatedAt: string
    deletedAt: any
    pacote_status: number
    step_atual: number
    institution_uuid: string
    ano_referencia_do_questionario: number
    anoReferencia: number
    prioridadePoucosImoveisRegularizados: number
    prioridadeSemTratamentoResiduos: number
    prioridadeDegradacaoApp: number
    prioridadeDegradacaoSolo: number
    prioridadeDesmatamentoIlegal: number
    prioridadePerdaBiodiversidade: number
    prioridadeCriseHidrica: number
    prioridadePoluicaoAgua: number
    prioridadePoluicaoSolo: number
    prioridadeQueimadas: number
    prioridadeUsoAgrotoxicos: number
    prioridadeMudancasClimaticas: number
    prioridadeOutroProblema: number
    descricaoOutroProblema: string
    created_by: string
    updated_by: string
    deleted_by: any
    pacote_formularios_uuid: string
}


export interface IQuestoesAmbientaisStore {
    questoes: IQuestoesAmbientais;
    setQuestoes: (questoes: IQuestoesAmbientais) => void;
    getQuestoes: (uuid: string) => Promise<IQuestoesAmbientais>;
    updateQuestoes: (uuid: string, data: Partial<IQuestoesAmbientais>) => Promise<boolean>;
    setPartialForm: (chave: keyof IQuestoesAmbientais, valor: any) => void;
    salvarRascunho: () => Promise<boolean>;
    enviarAprovacao: () => Promise<boolean>;
}

export const useQuestoesAmbientaisStore = create<IQuestoesAmbientaisStore>((set, get) => ({
    uuid: '',
    questoes: {} as IQuestoesAmbientais,
    setQuestoes: (questoes: IQuestoesAmbientais) => set({ questoes }),
    getQuestoes: async (uuid: string) => {
        const response = await QuestoesAmbientaisAPI.getByUUID(uuid);
        set({ questoes: response.dados });
        return response.dados;
    },
    updateQuestoes: async (uuid: string, data: Partial<IQuestoesAmbientais>) => {
        const response = await QuestoesAmbientaisAPI.update(uuid, data);
        if (response.Status === 'OK') {
            // Atualizar o estado local após sucesso
            set((state) => ({
                questoes: { ...state.questoes, ...data }
            }));
            return true;
        }
        return false;
    },
    setPartialForm: (chave: keyof IQuestoesAmbientais, valor: any) => {
        set((state) => ({
            questoes: { ...state.questoes, [chave]: valor }
        }));
    },
    salvarRascunho: async () => {
        const { questoes } = get();
        if (!questoes.uuid) return false;

        const data = {
            ...questoes,
            pacote_status: PacoteStatusEnum.RASCUNHO
        };

        return await get().updateQuestoes(questoes.uuid, data);
    },
    enviarAprovacao: async () => {
        const { questoes } = get();
        if (!questoes.uuid) return false;

        const data = {
            ...questoes,
            pacote_status: 3
        };

        return await get().updateQuestoes(questoes.uuid, data);
    }
}));